import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { THEME } from 'src/enums/theme';

import styles from './SubNavTitle.module.scss';

interface SubNavTitleProps {
  text: string;
  theme?: THEME;
}

export const SubNavTitle: FunctionComponent<SubNavTitleProps> = ({ text, theme = THEME.LIGHT }) => (
  <div className={classNames(styles.subNavTitle, styles[theme])}>{text}</div>
);
